const revenueByConsu = (revenues: any) => {
  let data: any = [];
  const result = revenues.filter((revenue: any) => revenue._id === "CONSUM")[0];
  const consumable = result === undefined ? [] : result;

  consumable?.list?.forEach((consu: any) => {
    consu?.list?.forEach((item: any) => {
      data.push(item);
    });
  });

  return { consumable, data };
};

export default revenueByConsu;
